var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5f6aeabbfd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 3 L 133 3 L 133 146 L 15 146 Z M 15 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "98cd0fbf69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95cdf4b328"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "483ee9addc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 1 L 136 1 L 136 149 L 12 149 Z M 12 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0f963681b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8a0423f1e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd33adf8e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 71 L 128 71 L 128 94 L 81 94 Z M 81 71 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e51de188eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "369eb95687"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e45c16f1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78 69 L 131 69 L 131 97 L 78 97 Z M 78 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8e61aa77db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ea35ad9bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "630359672b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76 90 L 126 90 L 126 110 L 76 110 Z M 76 90 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c96d5c40c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "513d9f296f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ae951a122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 88 L 128 88 L 128 113 L 74 113 Z M 74 88 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "478f6fb6eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afabf9afc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca80461f8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76 108 L 119 108 L 119 125 L 76 125 Z M 76 108 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e85f03f21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3f812d012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "965969b7fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 105 L 122 105 L 122 128 L 74 128 Z M 74 105 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a36ee59f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f8cb840a7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "364236fca3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 123 L 106 123 L 106 139 L 77 139 Z M 77 123 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91f647175a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db96bd5527"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4ad02d60d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 120 L 108 120 L 108 141 L 75 141 Z M 75 120 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f43304279e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "641365af5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -17.570312 34.214844 L 105.410156 -11.636719 L 155.453125 122.589844 L 32.472656 168.441406 Z M -17.570312 34.214844 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f6aeabbfd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#98cd0fbf69)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95cdf4b328)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cb38",
    d: "M 20.503906 90.566406 C 23.8125 86.925781 32.070312 87.222656 36.316406 83.269531 C 44.03125 76.097656 50.148438 58.21875 53.007812 53.292969 C 58.144531 44.445312 64.015625 39.335938 65.210938 29.707031 C 65.824219 24.765625 64.863281 13.65625 67.621094 7.550781 C 68.238281 6.1875 70.199219 4.398438 71.664062 4.085938 C 75.335938 3.300781 78.238281 4.902344 81.414062 6.882812 C 84.144531 8.585938 86.546875 11.058594 87.484375 14.128906 C 90.820312 25.054688 81.96875 36.417969 82.636719 47.824219 C 82.882812 52.023438 82.539062 57.640625 86.042969 59.976562 C 90.480469 62.929688 103.566406 57.082031 112.277344 58.027344 C 117.75 58.625 124.074219 59.011719 128.082031 62.761719 C 131.277344 65.75 132.824219 70.675781 132.660156 75.042969 C 132.53125 78.5 129.757812 80.480469 129.800781 83.9375 C 129.84375 87.453125 133.25 90.441406 132.96875 93.945312 C 132.648438 97.957031 128.03125 101.214844 127.023438 105.113281 C 126.300781 107.90625 127.894531 109.695312 126.9375 112.417969 C 125.40625 116.773438 121.214844 117.792969 119.273438 121.988281 C 118.054688 124.617188 117.867188 128.378906 116.414062 130.882812 C 114.234375 134.628906 109.765625 136.796875 105.675781 138.242188 C 100.859375 139.949219 97.351562 139.003906 92.433594 140.382812 C 87.84375 141.671875 82.394531 145.625 77.640625 145.898438 C 65.847656 146.578125 56.433594 136.863281 44.433594 133.664062 C 39.785156 132.425781 34.664062 137.972656 30.207031 136.175781 C 22.285156 132.980469 18.707031 123.738281 16.851562 115.421875 C 14.941406 106.851562 14.578125 97.082031 20.503906 90.566406 Z M 20.503906 90.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#483ee9addc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0f963681b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8a0423f1e)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.493107, -0.183843, 0.183101, 0.491119, -199.64776, -82.636896)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 277.001132 456.361907 C 285.308661 452.058777 299.814413 458.093263 309.998575 453.856319 C 328.495377 446.177166 351.25497 418.292415 359.615769 411.392432 C 374.634678 398.999214 388.479634 393.778312 396.99957 377.361551 C 401.371629 368.936632 407.03516 348.436138 415.998212 339.359559 C 418.00205 337.333795 422.681036 335.442469 425.496591 335.860125 C 432.555459 336.903791 436.659882 341.701266 440.999633 347.358349 C 444.730619 352.222832 447.366569 358.2443 446.997675 364.357881 C 445.68464 386.113086 422.381666 400.527529 415.999445 421.363479 C 413.650147 429.034369 409.309394 438.847011 413.997401 445.358252 C 419.937956 453.595061 447.118827 451.862984 462.000921 459.358675 C 471.348116 464.074577 482.351516 468.980951 486.998054 478.355936 C 490.70359 485.827686 490.188004 495.664399 486.996935 503.362198 C 484.472628 509.456357 478.21995 511.148332 476.001662 517.357045 C 473.744478 523.670505 477.825582 531.282843 474.998915 537.359264 C 471.765609 544.317458 461.382276 547.064073 457.000092 553.361543 C 453.859435 557.87284 455.509478 562.133337 451.998197 566.362729 C 446.380666 573.128358 438.241207 572.157417 431.999716 578.363372 C 428.084683 582.250734 425.253798 588.850526 421.004442 592.358219 C 414.636891 597.602301 405.24129 598.499554 397.000025 598.357465 C 387.291404 598.198997 381.673339 594.171149 372.0017 593.358407 C 362.973917 592.603747 350.647623 596.038818 342.001908 593.359195 C 320.553655 586.714339 310.240921 563.072882 290.998891 549.355787 C 283.544446 544.043986 270.744431 550.546869 264.001578 544.36405 C 252.017949 533.371977 251.782198 514.465087 253.999054 498.361337 C 256.287084 481.767234 262.125331 464.060289 277.001132 456.361907 Z M 277.001132 456.361907 ",
    stroke: "#1c4d1d",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd33adf8e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e51de188eb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#369eb95687)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cb38",
    d: "M 127.917969 84.921875 C 127.917969 84.921875 115.097656 93.484375 108.40625 93.59375 C 99.746094 93.734375 94.363281 91.679688 85.175781 90.789062 C 83.339844 90.609375 81.09375 88.0625 81.527344 86.273438 C 82.664062 81.597656 87.699219 77.429688 92.058594 75.355469 C 97.707031 72.664062 105.578125 74.523438 110.410156 74.109375 C 111.917969 73.976562 114.820312 71.625 114.820312 71.625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e45c16f1a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e61aa77db)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ea35ad9bf)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.493107, -0.183843, 0.183101, 0.491119, -199.64776, -82.636896)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 471.995931 517.861915 C 471.995931 517.861915 443.485872 524.624309 431.499394 520.360066 C 415.986865 514.839532 407.766819 507.5788 391.999916 499.863248 C 388.850355 498.318386 386.541871 492.268378 388.501461 489.359089 C 393.629165 481.75789 405.360846 477.662777 414.499475 476.860222 C 426.342939 475.813482 439.122954 484.383477 448.001116 486.863776 C 450.773898 487.631295 457.502423 485.361837 457.502423 485.361837 ",
    stroke: "#1c4d1d",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#630359672b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c96d5c40c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#513d9f296f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cb38",
    d: "M 125.175781 104.683594 C 125.113281 104.511719 113.664062 109.605469 105.796875 109.949219 C 98.636719 110.261719 93.671875 108.261719 80.503906 107.632812 C 74.941406 107.367188 77.3125 104.273438 77.410156 102.351562 C 77.625 98.277344 83.265625 90.941406 83.265625 90.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ae951a122)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#478f6fb6eb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#afabf9afc4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.493107, -0.183843, 0.183101, 0.491119, -199.64776, -82.636896)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 453.995616 551.361949 C 453.998428 551.013036 430.232138 552.488228 415.996634 547.859325 C 403.040724 543.645787 395.528558 536.761392 372.500805 526.860758 C 362.773242 522.678542 369.048558 518.728215 370.498182 515.357599 C 373.585191 508.217381 388.497806 498.862486 388.497806 498.862486 ",
    stroke: "#1c4d1d",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca80461f8f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e85f03f21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3f812d012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cb38",
    d: "M 118.597656 121.679688 C 118.597656 121.679688 108.65625 125.121094 103.628906 124.464844 C 96.007812 123.464844 87.335938 123.34375 79.839844 122.425781 C 77.722656 122.164062 76.796875 119.019531 76.65625 116.898438 C 76.453125 113.8125 80.195312 108.308594 80.195312 108.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#965969b7fb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a36ee59f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f8cb840a7a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.493107, -0.183843, 0.183101, 0.491119, -199.64776, -82.636896)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 431.001351 577.361301 C 431.001351 577.361301 411.016515 576.887573 402.501083 572.363721 C 389.595729 565.496638 374.236065 559.500424 361.498818 552.863299 C 357.902951 550.984339 358.341976 544.74589 359.499589 540.860322 C 361.186389 535.208264 371.502775 527.863165 371.502775 527.863165 ",
    stroke: "#1c4d1d",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#364236fca3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91f647175a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db96bd5527)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cb38",
    d: "M 105.269531 138.117188 C 105.269531 138.117188 86.40625 138.992188 79.976562 136.355469 C 78.257812 135.652344 77.996094 131.980469 77.933594 130.125 C 77.835938 127.160156 81.035156 123.375 81.035156 123.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4ad02d60d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f43304279e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#641365af5e)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.493107, -0.183843, 0.183101, 0.491119, -199.64776, -82.636896)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 396.359683 597.863242 C 396.359683 597.863242 362.193275 586.855233 352.49565 577.85628 C 349.902198 575.453783 351.873623 568.715202 352.994012 565.356557 C 354.788215 559.99127 362.996944 555.356867 362.996944 555.356867 ",
    stroke: "#1c4d1d",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedIcon);
export default __webpack_public_path__ + "static/media/passed-icon.97629cce82bcf1303223d90a9cdbe816.svg";
export { ForwardRef as ReactComponent };